import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Form } from "formsy-react";
import Dialog from "components/dialog";
import Button from "components/form/button";
import Label from "components/form/label";
import TextField from "components/form/text-field";
import BaseAvatar from "components/site-nav/avatar";
import NavigationArrowForward from "material-ui/svg-icons/navigation/arrow-forward";
import NavigationArrowDownward from "material-ui/svg-icons/navigation/arrow-downward";
import Globalize from "globalize";
import theme from "styles/theme";
import { $, merge } from "glamor";
import classNames from "classnames";
import Checkbox from "material-ui/Checkbox";
import CircularProgress from "material-ui/CircularProgress";
import SelectField from "components/form/select-field";
import MenuItem from "material-ui/MenuItem";
import { format } from "lib/globalize-util";
import { Reasons } from "./request-access-popup";
import { DATATEST } from "constants/integration";

const MUIstyles = {
    actionButton: {
        margin: "12px",
    },
    actionButtonMobile: {
        margin: "0px",
    },
    actionsContainer: {
        padding: "0px 20px 24px 20px",
    },
    actionsContainerMobile: {
        display: "flex",
        justifyContent: "space-between",
    },
    circularProgress: {
        position: "fixed",
        margin: "auto",
        overflow: "show",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
    },
    div: {
        display: "flex",
        paddingTop: "8px",
    },
    hint: {
        bottom: 0,
        padding: "20px 0px 46px 16px",
        top: 0,
    },
    hintMobile: {
        padding: "20px 0px 24px 16px",
    },
    requestBrandLogo: {
        marginRight: "24px",
    },
    requestBrandLogoMobile: {
        marginRight: "36px",
    },
    requestArrow: {
        height: "48px",
        width: "48px",
        stroke: "aliceblue",
        flex: "0 10%",
        alignSelf: "center",
        color: theme.palette.primary1Color,
        margin: "4px 24px",
    },
    title: {
        paddingBottom: "0px",
        marginLeft: "12px",
    },
};

/** @augments {PureComponent<any, any>} */
class RequestBrandAccess extends PureComponent {
    static contextTypes = {
        me: PropTypes.object.isRequired,
        viewport: PropTypes.string.isRequired,
    };

    styles = merge(
        $(".requestAccessDisabled", {
            opacity: 0.5,
        }),
        $(" .requestAccessDetails", {
            display: "flex",
            backgroundColor: theme.palette.lightestGrey,
            border: `1px solid ${theme.palette.lightGrey}`,
            borderRadius: "4px",
            padding: "10px 16px",
            margin: "8px 0 24px",
        }),
        $(" .requestAccessDetailsMobile", {
            display: "flex",
            flexDirection: "column",
            backgroundColor: theme.palette.lightestGrey,
            border: `1px solid ${theme.palette.lightGrey}`,
            borderRadius: "4px",
            padding: "10px 16px",
            margin: "8px 0 24px",
        }),
        $(" .requestAccessBuyerInfo", {
            flex: "0 45%",
        }),
        $(" .requestAccessBrandInfo", {
            flex: "0 45%",
            minWidth: 0,
        }),
        $(" .requestAccessBrandName", {
            alignSelf: "center",
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
        }),
        $(" .requestAccessBuyerInfoCompany", {
            fontWeight: "bold",
        }),
        $(" .error", {
            color: "red",
        }),
        $(" .reason-check", {
            display: "inline-block !important",
            maxWidth: "410px",
        }),
    );

    render() {
        const {
            allowErrors,
            onCloseDialog,
            onChange,
            message,
            onSubmitRequest,
            brandInfo = {},
            disabled,
            retailerId,
            reasons,
            onRetailerChange,
        } = this.props;
        const { me, viewport } = this.context;

        const brandName = brandInfo.name || "";
        const brandLogo = brandInfo.dashboard_logo_image || "";
        const brandInitials = brandInfo.initials || "";
        let retailerName = "";
        const retailerOptions = me.retailers.map((retailer) => {
            if (retailer._id === retailerId) {
                retailerName = retailer.name;
            }
            return <MenuItem key={retailer._id} value={retailer._id} primaryText={retailer.name} />;
        });
        return (
            <Dialog
                title={Globalize.formatMessage("Request to connect with |brandName|", { brandName })}
                open={true}
                onRequestClose={onCloseDialog}
                autoScrollBodyContent={true}
                actions={[
                    <Button
                        data-test={DATATEST.MODAL_PROMPT_CANCEL}
                        key="cancel"
                        style={viewport !== "mobile" ? MUIstyles.actionButton : MUIstyles.actionButtonMobile}
                        label={Globalize.formatMessage("Cancel")}
                        onClick={onCloseDialog}
                        disabled={disabled}
                    />,
                    <Button
                        data-test={DATATEST.MODAL_PROMPT_CONFIRM}
                        key="submit"
                        primary
                        style={viewport !== "mobile" ? MUIstyles.actionButton : MUIstyles.actionButtonMobile}
                        label={
                            viewport !== "mobile"
                                ? Globalize.formatMessage("Submit Request")
                                : Globalize.formatMessage("Submit")
                        }
                        onClick={onSubmitRequest}
                        disabled={disabled}
                    />,
                ]}
                actionsContainerStyle={
                    viewport !== "mobile" ? MUIstyles.actionsContainer : MUIstyles.actionsContainerMobile
                }
                contentStyle={{ maxWidth: "1000px" }}
            >
                {disabled && <CircularProgress style={MUIstyles.circularProgress} />}
                <div
                    {...this.styles}
                    className={classNames({
                        requestAccessDisabled: disabled,
                    })}
                >
                    <Form>
                        <div
                            className={classNames({
                                requestAccessDetails: viewport !== "mobile",
                                requestAccessDetailsMobile: viewport === "mobile",
                            })}
                        >
                            <div className="requestAccessBuyerInfo">
                                <Label>{Globalize.formatMessage("Your info")}</Label>
                                {retailerOptions.length === 1 && (
                                    <h4 className="requestAccessBuyerInfoCompany">{retailerName}</h4>
                                )}
                                {retailerOptions.length !== 1 && (
                                    <SelectField
                                        name="retailer"
                                        inputStyle={{ backgroundColor: "white" }}
                                        value={retailerId}
                                        onChange={onRetailerChange}
                                    >
                                        {retailerOptions}
                                    </SelectField>
                                )}
                                <h4>{me.name}</h4>
                                <h5>{me.email}</h5>
                            </div>
                            {viewport !== "mobile" ? (
                                <NavigationArrowForward style={MUIstyles.requestArrow} />
                            ) : (
                                <NavigationArrowDownward style={MUIstyles.requestArrow} />
                            )}
                            <div className="requestAccessBrandInfo">
                                <Label>{Globalize.formatMessage("Requesting Access to")}</Label>
                                <div style={MUIstyles.div}>
                                    <BaseAvatar
                                        key="0"
                                        dark={true}
                                        label={brandInitials}
                                        src={`//cdn1.nuorder.com/brands/${brandLogo}.png`}
                                        style={
                                            viewport !== "mobile"
                                                ? MUIstyles.requestBrandLogo
                                                : MUIstyles.requestBrandLogoMobile
                                        }
                                    />
                                    <div className="requestAccessBrandName">{brandName}</div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <Label>{format("What are the reasons for your request? Select all that apply")}*</Label>
                            {allowErrors && reasons.isEmpty() && (
                                <p className="error">{format("You must select at least 1 reason")}</p>
                            )}
                            <Checkbox
                                data-test={DATATEST.REQUEST_BRAND_ACCESS.PRODUCT_INFO}
                                className="reason-check"
                                checked={reasons.includes(Reasons.PRODUCT_INFO)}
                                value={Reasons.PRODUCT_INFO}
                                onCheck={onChange}
                                label={format(Reasons.PRODUCT_INFO)}
                            />
                            <Checkbox
                                data-test={DATATEST.REQUEST_BRAND_ACCESS.ORDER}
                                className="reason-check"
                                checked={reasons.includes(Reasons.ORDER)}
                                value={Reasons.ORDER}
                                onCheck={onChange}
                                label={format(Reasons.ORDER)}
                            />
                            <Checkbox
                                data-test={DATATEST.REQUEST_BRAND_ACCESS.FOLLOW_UP}
                                className="reason-check"
                                checked={reasons.includes(Reasons.FOLLOW_UP)}
                                value={Reasons.FOLLOW_UP}
                                onCheck={onChange}
                                label={format(Reasons.FOLLOW_UP)}
                            />
                            <Checkbox
                                data-test={DATATEST.REQUEST_BRAND_ACCESS.BRAND_INFO}
                                className="reason-check"
                                checked={reasons.includes(Reasons.BRAND_INFO)}
                                value={Reasons.BRAND_INFO}
                                onCheck={onChange}
                                label={format(Reasons.BRAND_INFO)}
                            />
                        </div>
                        <TextField
                            data-test={DATATEST.REQUEST_BRAND_ACCESS.MESSAGE}
                            fullWidth
                            label={Globalize.formatMessage("Message to Brand: (optional)")}
                            large={true}
                            multiLine={true}
                            name="message"
                            onChange={onChange}
                            hintStyle={viewport !== "mobile" ? MUIstyles.hint : MUIstyles.hintMobile}
                            hintText={Globalize.formatMessage(
                                "Tell the brand a little about why you want to buy from them.",
                            )}
                            rows={4}
                            rowsMax={4}
                            value={message}
                            disabled={disabled}
                        />
                    </Form>
                </div>
            </Dialog>
        );
    }
}

export default RequestBrandAccess;
